import Cookies from 'universal-cookie';
import { REDIRECT_URL_DEVELOPER, AUTH_URL, REDIRECT_URL } from "../../Config/AppConfiguration";

class Login {


  getLoginUrl = function () {


    // Uncomment below lines while running on localhost
    // let URL =
    //   "http://localhost:3000/developer/#access_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJkaXIiLCJlbmMiOiJBMjU2Q0JDLUhTNTEyIn0..1T3QDAn43YMCEwIAdHDY7w.nfBPE-r8PtdseiTkd97sHv71Ja9JFLClaof4NsdbRwCi-XjEppgbyBbgQUT0jq5x5HcKlrtjovEI9zGa14Oyo49B7r2nSHBxxZ92PKoK63r8pBG_0PCxBFo35UHn5WQNkx1FlPG3Z9Iwkh5GiOhAXxbGcJEvNXPe1GRp4mrO5l6wB6tAonyS7sIydrqOhL_Cccey1FIWJ4Blrl1fggEocMG3Yg8I7gPJoEe_aSqNcBIoSSUaSP6qbEKAacMHgv_M-Arguxl5qkdL0RSukzg8xEJIaqDHieEGiwnpyQ_cddNXbPgR-8Qf6NuyBQvUpmpgUm8rmbDQuNoqD8f7Y8MUtNX6wP0ltS9e8-UQErf1JIcrAiDL_O-ShjIc0Vat4r23PDyFjqisOy7bbYH1vw_8LJhD83DUDTao64yDfPc1oBj9kViJzMGqemtqKOZFmnDAbd10_ffCd5gtj75fMOpRTNNZPPx1HFVd4cuQBGqZwr6uewOH4r61jCSlJs4SdNfmFU1N3rf2hhT38buN83s-BIfA0M4NN6upPmtHZZYoPuW6OpV6HYL-Tsl7nFZKs4R3kPtB1c9xvboM0yawNrM1qPAK6uCHqjfOQ6V0JaQ34SqlJpGREXZKnkG7jPZlRemEMBiruL2Xepugc0ugnsaiPRbYcWkRhKfTDliMCjGigM9kH4IklGyb3Ck9kCLUBnGR9G-HIyks4JPJCcB5on4kMm-taH_2v8lsQOnsVoOWtRWsw9WT9N2Ct6pPpTcE5bkQ6eRmreN1oxEN1sbRpyySp7c-3G1QwmbnljSkZR0TLW8hPWPXMK0hkd7HINdW9J_j_v8b2UvvWNzk47YXThGH2vOlZe1mNRygzBrwO_PAJ4T2cGjYMV0Tcgzt-th07VoSH0Vmh2S6-z5mETglgK8bI-EIgNhTLfsuOdUFYS9k951xHuwH04Wjcsq5ojy-z8JNx-Ak28XYVJCQAW8neih4R2LpB2VK_31PQMUJgGacRWkDSuS_BQ643HLt-x_csD85_O6ikTJQYj1pkQRiBqduqBH5a1fZkihFBxnShrnpu3TI0gmg0vl9qUCrAv3ViBRcU05hFR4evl3frdJxBeRHjjWT5N7KNffJdMVJy4ba8DahhZoFtjUZgxSSdXh64fkZmueRD31SxJTweWTnCc4piJoL45eSSPAQhPBfiXj3nrk.JRg-3YtYFg7_PA93G4deqEJrz3uY-WE1-feRSliDFSY&token_type=Bearer&expires_in=3600";


    // return URL;


    // Restore this block before pushing your code
     return (
          // const nonce = btoa(Math.random()).slice(0, 24);
          AUTH_URL +
             "&redirect_uri=" + encodeURIComponent(REDIRECT_URL+"/home") +
             "&nonce=" + btoa(Math.random()).slice(0, 24) +
             "&code_challenge=" + sessionStorage.getItem('codeChallenge') +
             "&state=" + sessionStorage.getItem('oauthState')

     )


  }

  //setAuthUrl(newAuthUrl);
  //console.log("Auth was called for the first time. Redirecting to:", newAuthUrl);
  // window.location.href = newAuthUrl;
  // The below commented code is of no use as  of now.

  // return (
  //   AUTH_URL +
  //   "&redirect_uri=" +
  //   encodeURIComponent(REDIRECT_URL_DEVELOPER) +
  //   "&nonce=" +
  //   btoa(Math.random()).slice(0, 24)
  // )

  loginAndRedirectToChangePassword = function (REDIRECT_URL_DEVELOPER) {
    console.log("redirecturl in chnagepassword method:---->" + REDIRECT_URL_DEVELOPER);
    var redirTo = REDIRECT_URL_DEVELOPER;
    var authUrl = AUTH_URL;
    return (
      authUrl +
      "&redirect_uri=" +
      encodeURIComponent(redirTo) +
      "&nonce=" +
      btoa(Math.random()).slice(0, 24)
    )

  }

  currentUserTokenExpired = function () {
    var _user_attributes = new Cookies().get("currentAPIMUser");
    if (_user_attributes) {
      _user_attributes = decodeURI(_user_attributes);
      const currentUserFromCookie = JSON.parse(_user_attributes);
      if (currentUserFromCookie.accessTokenExpiry != null) {
        let accessTokenExpiryFromCookie = new Date(
          currentUserFromCookie.accessTokenExpiry
        );
        if (typeof accessTokenExpiryFromCookie.getMonth == "function") {
          if (accessTokenExpiryFromCookie > new Date()) {
            return false;
          }
        }
      }
    }
    return true;
  };

  getParameterByName = function (name) {
    // name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&#]" + name + "(=([^&#]*)|&|#|$)"),
      ful = regex.exec(window.location.href);
    console.log('ABC', window.location.href);
    if (!ful) return null;
    if (!ful[2]) return "";
    return decodeURIComponent(ful[2].replace(/\+/g, " "));
  };

  setCurrentUserObject = function (data, accessTokenExpiresIn) {
    // Helper to capitalize first letter
    const capitalize = str => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

    const name = capitalize(data.name);
    const surName = capitalize(data.surName);

    return {
      accountStatus: data.accountStatus,
      displayName: name + (surName ? " " + surName : ""),
      email: data.email,
      id: data.id,
      lastLogin: data.lastLogin,
      mobileNumber: data.mobileNumber,
      accessTokenExpiry: new Date().setSeconds(accessTokenExpiresIn),
    };
  }
}
export default new Login();